var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getUrls } from '@shared/utils/config/environment';
import { ChainId, WRAPPED_SOL } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
export function userBalanceERC20(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var evmAssetsPromise, svmAssetsPromise, _c, evmAssets, svmAssets, payload, svmPayload, svmIndex, flattenedBalances, chainIds, url, response, payload, responseBalances, tokenBalances, flattenedBalances, _d, totalUsdValue_1, totalUsdValue24h;
        var _e, _f, _g;
        var address = _b.address, solanaAddress = _b.solanaAddress, 
        // Using solana chainId from Covalent here not defined
        _h = _b.chains, 
        // Using solana chainId from Covalent here not defined
        chains = _h === void 0 ? [1, 137, 10, 56, 43114, 42161, 250, 1399811149] : _h, useGeniusAPI = _b.useGeniusAPI;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!(useGeniusAPI === true)) return [3 /*break*/, 4];
                    evmAssetsPromise = fetch("".concat(getUrls().INDEXER_URL, "/portfolio/assets?address=").concat(address));
                    svmAssetsPromise = fetch("".concat(getUrls().INDEXER_URL, "/portfolio/assets?address=").concat(solanaAddress, "&chains=").concat(1399811149));
                    return [4 /*yield*/, Promise.all([evmAssetsPromise, svmAssetsPromise])];
                case 1:
                    _c = _j.sent(), evmAssets = _c[0], svmAssets = _c[1];
                    return [4 /*yield*/, evmAssets.json()];
                case 2:
                    payload = _j.sent();
                    if (payload.status == 'error') {
                        throw new Error('Failed to fetch user balance');
                    }
                    return [4 /*yield*/, svmAssets.json()];
                case 3:
                    svmPayload = _j.sent();
                    if (svmPayload.status == 'error') {
                        throw new Error('Failed to fetch user balance');
                    }
                    svmIndex = payload === null || payload === void 0 ? void 0 : payload.data.findIndex(function (x) { return x.chainId == 1399811149; });
                    payload.data[svmIndex] = svmPayload === null || svmPayload === void 0 ? void 0 : svmPayload.data[0];
                    payload['solanaAddress'] = solanaAddress;
                    payload.totalUsdValue += svmPayload === null || svmPayload === void 0 ? void 0 : svmPayload.data[0].totalUsdValue;
                    payload.totalUsdValue24h += svmPayload === null || svmPayload === void 0 ? void 0 : svmPayload.data[0].totalUsdValue24h;
                    payload.data.forEach(function (chainData) {
                        var _a;
                        chainData['balances'] = (_a = chainData === null || chainData === void 0 ? void 0 : chainData.balances) === null || _a === void 0 ? void 0 : _a.map(function (balance) {
                            if (balance.contract_address == '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' &&
                                (balance.network == ChainId.SOLANA || balance.network == ChainId.SOLANA_DLN)) {
                                balance.contract_address = WRAPPED_SOL;
                            }
                            return __assign({}, balance);
                        });
                    });
                    flattenedBalances = (_e = payload.data
                        .map(function (chainBalances) {
                        return chainBalances.balances;
                    })
                        .flat()) === null || _e === void 0 ? void 0 : _e.sort(function (a, b) {
                        if (!a.usdValue && !b.usdValue) {
                            return 0;
                        }
                        if (!a.usdValue) {
                            return 1;
                        }
                        if (!b.usdValue) {
                            return -1;
                        }
                        return b.usdValue - a.usdValue;
                    });
                    return [2 /*return*/, {
                            balancesByChain: payload.data,
                            balances: flattenedBalances,
                            totalUsdValue: payload === null || payload === void 0 ? void 0 : payload.totalUsdValue,
                            totalUsdValue24h: payload === null || payload === void 0 ? void 0 : payload.totalUsdValue24h,
                        }];
                case 4:
                    chainIds = chains.join(',');
                    url = "/api/user/erc20?chains=".concat(chainIds, "&address=").concat(address, "&solana_address=").concat(solanaAddress);
                    return [4 /*yield*/, fetch(url)];
                case 5:
                    response = _j.sent();
                    return [4 /*yield*/, response.json()];
                case 6:
                    payload = _j.sent();
                    if (!payload || !payload.data || payload.error) {
                        throw new Error('Failed to fetch user balance');
                    }
                    responseBalances = payload === null || payload === void 0 ? void 0 : payload.data;
                    tokenBalances = (_f = responseBalances === null || responseBalances === void 0 ? void 0 : responseBalances.map(function (chainData) {
                        var _a;
                        var totalUsdValue = (_a = chainData === null || chainData === void 0 ? void 0 : chainData.balances) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, balance) {
                            var _a;
                            return acc + ((_a = balance.usd_value) !== null && _a !== void 0 ? _a : 0);
                        }, 0);
                        return __assign(__assign({}, chainData), { totalUsdValue: totalUsdValue, totalUsdRate: 0 });
                    })) === null || _f === void 0 ? void 0 : _f.sort(function (a, b) {
                        if (!(a === null || a === void 0 ? void 0 : a.totalUsdValue) && !(b === null || b === void 0 ? void 0 : b.totalUsdValue)) {
                            return 0;
                        }
                        if (!(a === null || a === void 0 ? void 0 : a.totalUsdValue)) {
                            return 1;
                        }
                        if (!(b === null || b === void 0 ? void 0 : b.totalUsdValue)) {
                            return -1;
                        }
                        return (b === null || b === void 0 ? void 0 : b.totalUsdValue) - (a === null || a === void 0 ? void 0 : a.totalUsdValue);
                    });
                    flattenedBalances = (_g = tokenBalances
                        .map(function (chainBalances) {
                        return chainBalances.balances;
                    })
                        .flat()) === null || _g === void 0 ? void 0 : _g.sort(function (a, b) {
                        if (!a.usdValue && !b.usdValue) {
                            return 0;
                        }
                        if (!a.usdValue) {
                            return 1;
                        }
                        if (!b.usdValue) {
                            return -1;
                        }
                        return b.usdValue - a.usdValue;
                    });
                    _d = flattenedBalances.reduce(function (_a, balance) {
                        var totalUsdValue = _a.totalUsdValue, totalUsdValue24h = _a.totalUsdValue24h;
                        return {
                            totalUsdValue: totalUsdValue + (Number.isNaN(balance === null || balance === void 0 ? void 0 : balance.quote) ? 0 : balance === null || balance === void 0 ? void 0 : balance.quote),
                            totalUsdValue24h: totalUsdValue24h + (Number.isNaN(balance === null || balance === void 0 ? void 0 : balance.quote_24h) ? 0 : balance === null || balance === void 0 ? void 0 : balance.quote_24h),
                        };
                    }, { totalUsdValue: 0, totalUsdValue24h: 0 }), totalUsdValue_1 = _d.totalUsdValue, totalUsdValue24h = _d.totalUsdValue24h;
                    tokenBalances.forEach(function (item) {
                        return (item.totalUsdRate = !totalUsdValue_1 ? 0 : ((item === null || item === void 0 ? void 0 : item.totalUsdValue) * 100) / totalUsdValue_1);
                    });
                    return [2 /*return*/, {
                            balancesByChain: tokenBalances,
                            balances: flattenedBalances,
                            totalUsdValue: totalUsdValue_1,
                            totalUsdValue24h: totalUsdValue24h,
                        }];
            }
        });
    });
}
export default function useERC20Balance(_a) {
    var _this = this;
    var evmAddresses = _a.evmAddresses, solanaAddresses = _a.solanaAddresses, _b = _a.chains, chains = _b === void 0 ? [1, 137, 10, 56, 43114, 42161, 8453, 1399811149] : _b;
    var _c = useLocalStorage("lastFetchedPortfolio", ''), setLastFetchedPortfolio = _c[1];
    var _d = useLocalStorage("portfolioData", null), portfolioDataLC = _d[0], setPortfolioDataLC = _d[1];
    //TODO refactor endpoint to handle multiple addresses
    var query = useQuery({
        queryKey: ['userbalance', evmAddresses, chains, solanaAddresses],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, userBalanceERC20({
                            address: evmAddresses === null || evmAddresses === void 0 ? void 0 : evmAddresses[0],
                            chains: chains,
                            useGeniusAPI: true,
                            solanaAddress: solanaAddresses === null || solanaAddresses === void 0 ? void 0 : solanaAddresses[0],
                        })];
                    case 1:
                        data = _a.sent();
                        setLastFetchedPortfolio(new Date().toISOString());
                        // const _transformedBalances = data.balances.map((token) => {
                        //   if (token.contract_address.toLocaleLowerCase() === NATIVE_ADDRESS.toLocaleLowerCase()) {
                        //     token.contract_address = WrappedNativeTokens.get(token.network);
                        //   }
                        //   return token;
                        // });
                        // const _transformedBalancesByChain = data.balancesByChain.map((chain) => {
                        //   const _balances = chain.balances.map((token) => {
                        //     if (token.contract_address.toLocaleLowerCase() === NATIVE_ADDRESS.toLocaleLowerCase()) {
                        //       token.contract_address = WrappedNativeTokens.get(token.network);
                        //     }
                        //     return token;
                        //   });
                        //   return {
                        //     ...chain,
                        //     balances: _balances,
                        //   };
                        // });
                        setPortfolioDataLC(__assign({}, data));
                        return [2 /*return*/, __assign({}, data)];
                }
            });
        }); },
        enabled: !!(evmAddresses === null || evmAddresses === void 0 ? void 0 : evmAddresses[0]),
        refetchInterval: 5000,
        gcTime: 1000 * 60 * 60 * 24 * 7,
    });
    return __assign(__assign({}, query), { data: portfolioDataLC || query.data, isLoading: !portfolioDataLC && query.isLoading });
}
